import {
  diagnosticsEnabled,
  logResourceTiming,
  logResourceTimingsSince,
  measureDiagnosticStep,
  measureDiagnosticSync,
} from "./perfDiagnostics";

const TASK_PERF_STORAGE_KEY = "vend:taskPerf";

export const taskPerfEnabled = () =>
  diagnosticsEnabled(TASK_PERF_STORAGE_KEY, "taskPerf");

export async function measureTaskStep<T>(
  label: string,
  action: () => Promise<T>,
  networkUrlFragment?: string,
): Promise<T> {
  const enabled = taskPerfEnabled();
  return measureDiagnosticStep(
    "task-perf",
    label,
    enabled,
    action,
    networkUrlFragment
      ? (startedAt) => {
          logResourceTimingsSince(
            "task-perf",
            label,
            networkUrlFragment,
            true,
            startedAt,
          );
        }
      : undefined,
  );
}

export function measureTaskSync<T>(label: string, action: () => T): T {
  return measureDiagnosticSync("task-perf", label, taskPerfEnabled(), action);
}

export function logTaskResourceTiming(label: string) {
  logResourceTiming("task-perf", label, "/task/", taskPerfEnabled());
}
